"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEVMChains = exports.chains = exports.idByChain = void 0;
var BSC = {
    id: 56,
    name: 'BNB Chain',
    symbol: 'BSC',
    token: {
        symbol: 'BNB',
    },
    explorer: 'https://bscscan.com/',
    urls: [
        'https://bsc-dataseed1.defibit.io/',
        'https://bsc-dataseed.binance.org/',
    ],
};
var BSC_TEST = {
    id: 97,
    name: 'Binance Smart Chain',
    symbol: 'BSC',
    token: {
        symbol: 'BNB',
    },
    explorer: 'https://testnet.bscscan.com/',
    urls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
};
// TODO: how to provide rpc urls?
var ETH = {
    id: 1,
    name: 'Ethereum',
    symbol: 'ETH',
    token: {
        symbol: 'ETH',
    },
    explorer: 'https://etherscan.io/',
    urls: [],
};
var ETH_ROPSTEN = {
    id: 3,
    name: 'Ethereum',
    symbol: 'ETH',
    token: {
        symbol: 'ETH',
    },
    explorer: 'https://ropsten.etherscan.io/',
    urls: [],
};
var POLY = {
    id: 137,
    name: 'Polygon',
    symbol: 'POLY',
    token: {
        symbol: 'MATIC',
    },
    explorer: 'https://polygonscan.com/',
    urls: ['https://polygon-rpc.com/'],
};
var AVAX = {
    id: 43114,
    name: 'Avalanche',
    symbol: 'AVAX',
    token: {
        symbol: 'AVAX',
    },
    explorer: 'https://snowtrace.io/',
    urls: ['https://api.avax.network/ext/bc/C/rpc'],
};
var FTM = {
    id: 250,
    name: 'Fantom Opera',
    symbol: 'FTM',
    token: {
        symbol: 'FTM',
    },
    explorer: 'https://ftmscan.com/',
    urls: ['https://rpcapi.fantom.network/'],
};
var ARB = {
    id: 42161,
    name: 'Arbitrum',
    symbol: 'ARB',
    token: {
        symbol: 'ETH',
    },
    explorer: 'https://arbiscan.io/',
    urls: ['https://arb1.arbitrum.io/rpc'],
};
var SOL = {
    name: 'Solana',
    symbol: 'SOL',
};
var TERRA = {
    name: 'Terra',
    symbol: 'TERRA',
};
var DOT = {
    name: 'Polkadot',
    symbol: 'DOT',
};
var ADA = {
    name: 'Cardano',
    symbol: 'ADA',
};
var ZKSYNC = {
    id: 324,
    name: 'ZKSync',
    symbol: 'ZKSYNC',
    token: {
        symbol: 'ETH',
    },
    explorer: 'https://explorer.zksync.io/',
    urls: ['https://mainnet.era.zksync.io'],
};
var SUI = {
    name: 'Sui',
    symbol: 'SUI',
};
var BASE = {
    id: 8453,
    name: 'BASE',
    symbol: 'BASE',
    token: {
        symbol: 'ETH',
    },
    explorer: 'https://basescan.org/',
    urls: ['https://mainnet.base.org'],
};
// evm-compatible only:
var chains = {
    BSC: BSC,
    BSC_TEST: BSC_TEST,
    ETH: ETH,
    ETH_ROPSTEN: ETH_ROPSTEN,
    POLY: POLY,
    AVAX: AVAX,
    FTM: FTM,
    ARB: ARB,
    BASE: BASE,
    ZKSYNC: ZKSYNC,
};
exports.chains = chains;
// not evm-compatible:
var notEVMChains = { SOL: SOL, TERRA: TERRA, DOT: DOT, ADA: ADA, ZKSYNC: ZKSYNC, SUI: SUI };
exports.notEVMChains = notEVMChains;
exports.idByChain = Object.keys(chains).reduce(function (acc, chain) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[chain] = chains[chain].id, _a)));
}, {});
